"use strict";
exports.__esModule = true;
exports.functionsDefault = void 0;
var utils_1 = require("../../utils");
exports.functionsDefault = [
    {
        name: 'isEmpty',
        minArity: 1,
        maxArity: 1,
        executor: function () { return function (value) { return utils_1.Objects.isEmpty(value); }; }
    },
];
//# sourceMappingURL=functionsDefault.js.map